const StatusCell = ({ status }) => {
  const color =
    ["SUCCESS", "SETTLED", "ACTIVE"].includes(status)
      ? "green"
      : ["FAILED", "SETTLEMENT_FAILED", "INACTIVE"].includes(status)
      ? "red"
      : ["PROCESSING", "SETTLEMENT_PROCESS", "PENDING"].includes(status)
      ? "orange"
      : "black";

  const displayStatus =
    status === "SETTLEMENT_PROCESS"
      ? "PROCESSING"
      : status === "SETTLEMENT_FAILED"
      ? "FAILED"
      : status;

  return (
    <p
      style={{
        color,
        fontWeight: "bold",
      }}
    >
      {displayStatus}
    </p>
  );
};

export default StatusCell;